export { default as ProfileCRMDetails } from './ProfileCRMDetails';
